import { MglMap } from '@advisr/v-mapbox';
import MapService from '@/services/mapService';
import { isInternetExplorer11 } from '@/utils/vuex';
import { resolveActiveMapStyle } from '@/utils/maps';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@advisr/v-mapbox/dist/v-mapbox.css';
import get from 'lodash/get';
export default {
  name: 'CoreMapboxMglMap',
  components: {
    MglMap
  },
  data() {
    return {
      hideToRefresh: false
    };
  },
  computed: {
    mapAccessToken() {
      return MapService.getAccessToken();
    },
    mapStyle() {
      const queryMapStyle = get(this.$route, 'query.mapstyle');
      const storeMapStyle = get(this.$store.state.app, 'mapStyle');
      return resolveActiveMapStyle(queryMapStyle, storeMapStyle, this.$store.state.app.UiTheme);
    },
    actualMapProps() {
      return {
        interactive: true,
        trackResize: true,
        accessToken: this.mapAccessToken,
        mapStyle: this.mapStyle,
        maxPitch: 60,
        ...this.$attrs
      };
    },
    isInteractive() {
      return this.actualMapProps.interactive;
    },
    /** Parent uses @load; that must not be forwarded to MglMap — only onMapLoaded + $emit('load'). */
    listenersWithoutLoad() {
      const rest = {
        ...this.$listeners
      };
      delete rest.load;
      return rest;
    }
  },
  watch: {
    isInteractive() {
      this.rebuildMap();
    },
    mapStyle(newStyle, oldStyle) {
      if (!this.map || !oldStyle || newStyle === oldStyle) {
        return;
      }
      this.rebuildMap();
    },
    '$store.state.app.map3DBuild': {
      handler() {
        this.toggleThreeDeeLayer();
      }
    }
  },
  created() {
    // mapbox-gl-draw cannot be correctly transpiled for IE11 (actually, not at all, atm),
    // so since the map needs to work in that browser and the dependency cannot be selectively excluded,
    // instead include it dynamically on runtime here, if the browser is not IE11
    // (NOTE: "isNotIE11" will literally also be true for IE10, but in that browser nothing works anyway, so have at it.)
    if (!isInternetExplorer11() && !window.didLoadMaboxGlDrawLib) {
      const script = document.createElement('script');
      script.src = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.css';
      css.type = 'text/css';
      document.getElementsByTagName('head')[0].appendChild(css);
      window.didLoadMaboxGlDrawLib = true;
    }
  },
  methods: {
    rebuildMap() {
      this.hideToRefresh = true;
      this.$nextTick(() => {
        this.hideToRefresh = false;
      });
    },
    onMapLoaded(event) {
      if (this.map && typeof this.map.remove === 'function') {
        try {
          this.map.remove();
        } catch (error) {
          console.warn('Error removing previous map instance:', error);
        }
      }
      const {
        map
      } = event;
      this.map = map;
      const observer = new ResizeObserver(() => {
        try {
          if (event.map && typeof event.map.resize === 'function') {
            event.map.resize();
            this.$emit('resize');
          }
        } catch (e) {
          console.warn('Could not resize map (observer)', e);
        }
      });
      if (map && typeof map.getContainer === 'function') {
        try {
          observer.observe(map.getContainer());
        } catch (error) {
          console.warn('Could not observe map container:', error);
        }
      }
      this.toggleThreeDeeLayer();
      this.$emit('load', event);
    },
    toggleThreeDeeLayer() {
      if (this.$store.state.app.map3DBuild) {
        this.addThreeDeeLayer();
      } else {
        this.removeThreeDeeLayer();
      }
    },
    addThreeDeeLayer() {
      if (this.map) {
        MapService.add3DBuildingLayer(this.map);
      }
    },
    removeThreeDeeLayer() {
      if (this.map) {
        MapService.remove3DBuildingLayer(this.map);
      }
    }
  }
};